<template>
  <div class="an-tiles an-tiles--flat">
    <div v-for="tile in tiles" :key="tile.id" class="an-tile">
      <div class="an-tile__top">
        <span class="an-tile__title">{{ tile.label }}</span>
      </div>
      <div class="an-tile__value">
        {{ tile.value }}
        <span v-if="tile.delta" class="an-change" :class="tile.delta.direction && 'an-change--' + tile.delta.direction">
          {{ tile.delta.text }}
        </span>
      </div>
      <div v-if="tile.prev" class="an-tile__sub">прошлый период: {{ tile.prev }}</div>
    </div>
  </div>
</template>

<script>
import {formatDelta, formatValue} from "@/common/viewFormat";

export default {
  name: "ViewKpi",
  props: {
    metrics: {type: Array, required: true},
  },
  computed: {
    tiles() {
      return this.metrics.map(m => ({
        id: m.id,
        label: m.label,
        value: formatValue(m.value, m.unit),
        prev: m.prev === undefined || m.prev === null ? '' : formatValue(m.prev, m.unit),
        delta: formatDelta(m.value, m.prev, {unit: m.unit, neutral: m.unit === '%', lowerIsBetter: !!m.lowerIsBetter}),
      }))
    },
  },
}
</script>
